import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {CustomerDiscountGroup} from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";
import DeletePop from "../../../Components/DeletePop";

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ShowModal: false,
      triggerModal: false,
      selectedType: false,
      btnDisable: false,
      type: "",
      name: "",
      percentage: "",
      amount: "",
      filterText: "",
      formError: false,
    };
    this.columns = [
      {
        name: "Discount Title",
        selector: row => row.name,
      },
      {
        name: "Discount Type",
        selector: row => row.type,
      },

      {
        name: "Percent",
        selector: row => row.percent,
      },
      {
        name: "Amount",
        selector: row => row.amount,
      },
      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        width: "150px",
        sortable: false,
        cell: (row) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button
                className="table-action btn btn-square btn-pure hover-danger"
                onClick={() =>
                  this.setState({ selectedId: row.id, triggerModal: true })
                }
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  componentDidMount() {
    this.fetchDiscount();
  }
  fetchDiscount() {
    ApiConnect.get("/Members/Information/DiscountGroup")
      .then((response) => {
        this.props.CustomerDiscountGroup(response.data);
      })
      .catch((error) => console.log(error));
  }
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  SettriggerModal = () => {
    this.setState({ selectedId: false, triggerModal: false });
  };
  handleSubmit(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdata = new FormData();
    Fdata.append("name", this.state.title);
    Fdata.append("type", this.state.type);
    Fdata.append("amount", this.state.amount || 0);
    Fdata.append("percentage", this.state.percentage || 0);
    ApiConnect({
      method: "post",
      url: "/Members/Information/NewDiscount",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            ShowModal: false,
            triggerModal: false,
            selectedType: false,
            btnDisable: false,
            type: "",
            name: "",
            percentage: "",
            amount: "",
            formError: false,
          });
          this.fetchDiscount();
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  }
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Discount</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => this.setState({ filterText: e.target.value })}
                />
              </div>
              <DataTable
                className="table table-separated"
                keyField="id"
                columns={this.columns}
                data={this.props.Discount.filter(item =>
                  Object.values(item).some(val =>
                    String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
                  )
                )}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={this.customStyles}
                filter
                exportable
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">New Discount</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <form onSubmit={(e) => this.handleSubmit(e)}>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Discount Title</label>
                      <input
                        type="text"
                        name="title"
                        value={this.state.title}
                        className="form-control"
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Discount Type</label>
                      <label className="col-12">
                        <select
                          className="form-control"
                          name="type"
                          value={this.state.type}
                          onChange={(e) => this.handleChange(e)}
                        >
                          <option>Select Group</option>
                          <option value="percentage">Percent</option>
                          <option value="amount">Amount</option>
                        </select>
                      </label>
                    </div>
                  </div>
                  <div className="row form-group">
                    {this.state.type === "percentage" ? (
                      <div className="col">
                        <label className="form-label">Discount Percent</label>
                        <label className="col-12">
                          <input
                            onChange={(e) => this.handleChange(e)}
                            value={this.state.percentage}
                            type="number"
                            className="form-control"
                            name="percentage"
                            required="required"
                            placeholder="000%"
                          />
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.type === "amount" ? (
                      <div className="col">
                        <label className="form-label">Discount Amount</label>
                        <label className="col-12">
                          <input
                            onChange={(e) => this.handleChange(e)}
                            value={this.state.amount}
                            type="number"
                            className="form-control"
                            name="amount"
                            required="required"
                            placeholder="00000000"
                          />
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={this.state.btnDisable}
                  >
                    Create
                  </button>
                </Modal.Footer>
              </form>
            </Modal.Dialog>
          </Modal>
          <DeletePop
            trigger={this.state.triggerModal}
            delUrl={`/Members/Information/DeleteDiscount?id=${this.state.selectedId}`}
            hideTrigger={this.SettriggerModal}
            fallAction={this.fetchDiscount}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    Discount: state.Customer.Discount,
  }),
  { CustomerDiscountGroup }
)(index);
